import React, { useState, useEffect, useRef } from 'react'
import { setLoading, setSnackInfo } from '../../redux/actions/appAction'
import { setVendorName } from '../../redux/actions/vendorAction'
import HttpService from '../../services/httpService'
import { connect } from 'react-redux'
import { useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import { makeStyles, useTheme, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import TableHead from '@material-ui/core/TableHead';
import { DownloadOutlined, FileFilled, RobotFilled, RollbackOutlined } from '@ant-design/icons';
import { Button, Input, Menu} from '@material-ui/core';
import moment from 'moment'
import { Link } from 'react-router-dom'
import { ROLENAME, designDepartment, constantDepartmentId, CURRENT_STAGE } from '../../utils/index';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Accordion, AccordionSummary, AccordionDetails, AccordionActions, Typography, Grid, Divider, DialogContentText, Box, OutlinedInput, Modal } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select/Select';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DeleteIcon from '@material-ui/icons/Delete'
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Card, CardContent } from '@material-ui/core';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import { Http, TabletAndroidOutlined, ThumbUpOutlined } from '@material-ui/icons';
import { CSVLink } from "react-csv";
import { IoEye } from "react-icons/io5";
import { FaDownload } from "react-icons/fa";
import AdmCheckList from './AdmCheckList'
import { FaExternalLinkAlt } from "react-icons/fa";


const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  // const { vendorDetail } = useSelector(state => state.vendor)

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
  table: {
    minWidth: 500,
  },
  textField: {
    width: "150px"
  },
  paperClass: {
    height: '100%'
  },
  returnButton: { backgroundColor: 'white', color: '#9c261e', padding: '1', marginBottom: '1px', borderRadius: '20px', "&:hover": { backgroundColor: "#9c261e", color: 'white' } },
  approveButton: { backgroundColor: 'white', color: '#157525', padding: '1', marginBottom: '1px', borderRadius: '20px', "&:hover": { backgroundColor: "#157525", color: 'white' } },
  UploadDocsbuttons: { borderRadius: 50, backgroundColor: 'white', color: '#2c2e3e', padding: '1', marginBottom: '1px', borderRadius: '20px', "&:hover": { backgroundColor: "#2c2e3e", color: 'white' } },
  deleteIcon: { cursor: "pointer", verticalAlign: 'middle', marginLeft: 10, color: "red", fontSize: 20 },
  submitButton: {
    backgroundColor: '#F47E46 !important',  // Decorpot Orange
    color: 'white',            // White text
    '&:hover': {
      backgroundColor: '#E0663D !important', // Darker Orange on hover
    },
  },
  searchButton: {
    backgroundColor: '#FDB913 !important',  // Bright Yellow for emphasis
    color: '#1C375D !important',            // Dark Blue text for contrast
    '&:hover': {
      backgroundColor: '#E6A411 !importan', // Darker yellow on hover
    },
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#1C375D",
    color: '#FFF2EB',
    fontWeight: "500"
  },
  body: {
    fontSize: 14,
    backgroundColor: "#fff",
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const styleForPopup = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const DrawingQcApproval = (props) => {
  let j = 1;
  const classes = useStyles2();
  useEffect(() => {
    getAllDesignKickOffLeads()
    getDepartments();
    getStages();
    // eslint-disable-next-line
  }, [])


  const { userDetails } = useSelector(state => state.user)
  const [designKickOffLeads, setDesignKickOffLeads] = useState([])
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, designKickOffLeads.length - page * rowsPerPage)
  const [open, setOpen] = React.useState(false);
  const [showChecklist, setShowChecklist] = useState(false);
  const [selectedDataForChecklist, setSelectedDataForChecklist] = useState(null);
  const [approvalMsg, setApprovalMsg] = useState({});
  const [selectedRowData, setSelectedRowData] = useState(null); 

  const handleOpen = (data) => {
    setSelectedRowData(data);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRowData(null);
  };
  


  const getAllDesignKickOffLeads = async () =>
  {
    props.setLoading(true)
    try {
      const response = await HttpService.getAllDrawingQcApprovalLeads(userDetails.selectedExpCenter)
      setDesignKickOffLeads(response.data)
    }
    catch(error){
      props.setSnackInfo(error)
    }
    props.setLoading(false)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [chmList, setChmList] = useState([]);
  const [stagesList, setStagesList] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [selectedStage, setSelectedStage] = useState([]);
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [searchbtn, setSearchBtn] = useState(false);
  const [csvData, setCsvData] = useState([]);
	const csvButtonRef = useRef(null);
  const [headers, setHeaders] = useState([]);

  const handleSearchUser = (event, newValue) => {
      setSelectedUser(newValue);
  }
  const handleSearchStage = (event, newValue) => {
    setSelectedStage(newValue);
  }
  const clearFilters = () => {
    setSelectedUser([]);
    setSelectedStage([]);
    setSearchBtn(false);
    getAllDesignKickOffLeads()
  };
  const getStages = async() => {
    try{
      const departmentss = await HttpService.getDepartments();
      const salesStage = departmentss.data.find(item=> item.name === "Design")
      if (salesStage){
        const suers = ["Won Deals Pending Designer Assignment", "Assign to Designer","Design Kick-Off : Internal","Design Kick-Off : Customer"]
        setStagesList(suers);
      }
    }catch(error){
      console.log(error,"get Stages");
    }
  }
  const getDepartments = async () => {
    try {
        const department = await HttpService.getDepartments();
        const chmStage = department.data.find(item=> item.name === "CHM")
        const designStage = department.data.find(item => item.name === "Design")
        const salesStage = department.data.find(item=> item.name === "Sales")
        if (chmStage || designStage || salesStage){
            const chm_users = chmStage.users
            const designUser = designStage.users
            const salesUser = salesStage.users
            const allUsers = chm_users.concat(designUser).concat(salesUser)
            setChmList(allUsers);
        }
    } catch (error) {
        console.log(error, "get department error")
    }
  }
  
  const searchFilter = () => {
    setSearchBtn(true);
  
    if (selectedUser.length > 0 || selectedStage.length > 0) {
      // Filter leads based on selected CHM users or designers or sales users
      const filteredData = designKickOffLeads.filter((data) => {
        const usersToCheck = [
          data.chmUser,
          data.designUser,
          data.salesWonUser,
          data.customerId,
        ];
  
        const userMatch = usersToCheck.some((user) => {
          return user && selectedUser.some((selected) => selected.name === user.name);
        });
  
        const stageMatch = selectedStage.some((stage) => stage === data.currentStage);
        if(selectedUser.length > 0 && selectedStage.length > 0){
          return userMatch && stageMatch
        }
        else {
          return  userMatch || stageMatch
        }
      });
  
      setFilteredLeads(filteredData);
      setPage(0);
    }
  };

  const prepareCSVData = () => {
    return (searchbtn ? filteredLeads : designKickOffLeads).map((data) => ({
      lead_no: data.lead_no || 'NA',
      erpProjectNo: data.erpProjectNo || 'NA',
      clientName: data.customerId ? data.customerId.name : 'NA',
      leadWonDate: data.leadWonDate ? moment(data.leadWonDate).format('DD-MM-YYYY') : 'NA',
      designerAssignedDate: data.designerAssignedDate ? moment(data.designerAssignedDate).format('DD-MM-YYYY') : 'NA',
      salesExecutive: data.salesWonUser ? data.salesWonUser.name : 'NA',
      designer: data.designUser ? data.designUser.name : 'NA',
      chm: data.chmUser ? data.chmUser.name : 'NA',
      currentStage: data.currentStage || 'NA',
    }));
  };
  

  const downloadCSV = () => {
    props.setLoading(true);
  
    try {
      const csvArray = prepareCSVData();
      setCsvData(csvArray);
      const headers = Object.keys(csvArray[0]).map((key) => ({
        key,
        label: key === "lead_no" ? "Lead no." : key.charAt(0).toUpperCase() + key.slice(1), // Customize label if needed
      }));
      setHeaders(headers);
      setTimeout(() => {
        csvButtonRef.current.link.click();
        props.setLoading(false);
      });
    } catch (error) {
      console.error(error.message);
      props.setLoading(false);
    }
  };
  
  const handleDownloadAll = (urls = []) => {
    urls.forEach((url, index) => {
      setTimeout(() => {
        const link = document.createElement('a');
        link.href = url;
        link.download = '';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }, index * 500); 
    });
  };

  const handleApproveClick = (e, data) => {
    e.preventDefault();
    setSelectedDataForChecklist(data); 
    setShowChecklist(true);
  };
  
  useEffect(() => {
    const handleApproval = async () => {
      if (approvalMsg?.data?.message === "Approved") {
        props.setSnackInfo("This is Approved", "success");
        props.setLoading(true);
  
        await new Promise(resolve => setTimeout(resolve, 500));
        await getAllDesignKickOffLeads();
  
        props.setLoading(false);
      } else if (approvalMsg?.data?.message === "Rejected") {
        props.setSnackInfo("This is Rejected", "success");
        props.setLoading(true);
  
        await new Promise(resolve => setTimeout(resolve, 500)); 
        await getAllDesignKickOffLeads();
  
        props.setLoading(false);
      }
    };
  
    handleApproval();
  }, [approvalMsg]);
  
  
  const quoClick = async (data) => {
    try {
      const fileUrl = data?.[0];
      if (!fileUrl) {
        console.warn("No file URL provided in data");
        return;
      }
      
      // Check if fileUrl has a PDF extension
      if (fileUrl.toLowerCase().endsWith(".pdf")) {
        if (fileUrl && typeof fileUrl === 'string') {
          window.open(fileUrl, '_blank'); 
        } else {
          console.warn("Invalid link returned from API");
        }
      }

      const response = await HttpService.quotationLink(data[0]);
      const link = response?.data?.links[0];
      if (link && typeof link === 'string') {
        window.open(link, '_blank'); 
      } else {
        console.warn("Invalid link returned from API");
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  
  return (
    <div >

      {/* heading */}
      <h1 style={{textAlign: 'center'}}>Drawing QC ADM Approval Dashboard</h1>
      <>
      </>
      <TableContainer component={Paper}>

        <Table className={classes.table} size="small" aria-label="custom pagination table">

          <TableHead>
          <TableRow>
              <TablePagination
                rowsPerPageOptions={[10, 20, 50, { label: 'All', value: designKickOffLeads?.length }]}
                colSpan={14}
                count={designKickOffLeads.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { 'aria-label': 'rows per page' },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>

            <TableRow>
              <StyledTableCell style={{textAlign: 'center'}}>Sl No.</StyledTableCell>
              <StyledTableCell style={{textAlign: 'center'}}>Lead No.</StyledTableCell>
              <StyledTableCell style={{textAlign: 'center'}}>Project No.</StyledTableCell>
              <StyledTableCell style={{textAlign: 'center'}}>Client Name</StyledTableCell>
              <StyledTableCell style={{textAlign: 'center'}}>Sales Won Date</StyledTableCell>
              <StyledTableCell style={{textAlign: 'center'}}>Sales Executive</StyledTableCell>
              <StyledTableCell style={{textAlign: 'center'}}>Designer</StyledTableCell>
              <StyledTableCell style={{textAlign: 'center'}}>ADM</StyledTableCell>
              <StyledTableCell style={{textAlign: 'center'}}>Current Lead Stage</StyledTableCell>
              <StyledTableCell style={{textAlign: 'center'}}>Current QC Stage</StyledTableCell>
              <StyledTableCell style={{textAlign: 'center'}}>Drawing QC Attachment</StyledTableCell>
              {!userDetails.roles.find(role=> role.name == ROLENAME.Admin ) && <StyledTableCell colSpan={3} style={{textAlign: 'center'}}>Action</StyledTableCell>}
            </TableRow>
          </TableHead>

          <TableBody>

            {/* designKickOffLeads */}
            {(rowsPerPage > 0 && searchbtn
              ? filteredLeads
              : designKickOffLeads.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              ).map((data, i) => (
              <>
                
                  <StyledTableRow key={j++}>

                  <StyledTableCell>{i + 1}</StyledTableCell>
                  <StyledTableCell>
                    {data?.lead_no ? (
                      <span
                        onClick={() => window.open(`/project-logs/${data._id}`, '_blank', 'noopener,noreferrer')}
                        style={{ color: "#000", textDecoration: 'underline', textAlign: 'center', cursor: 'pointer' }}
                      >
                        {data.lead_no}
                      </span>
                    ) : (
                      'NA'
                    )}
                  </StyledTableCell>

                  <StyledTableCell>
                    {data?.erpProjectNo ? (
                      <span
                        onClick={() => window.open(`/project-logs/${data._id}`, '_blank', 'noopener,noreferrer')}
                        style={{ color: "#000", textDecoration: 'underline', textAlign: 'center', cursor: 'pointer' }}
                      >
                        {data.erpProjectNo}
                      </span>
                    ) : (
                      'NA'
                    )}
                  </StyledTableCell>

                  <StyledTableCell>{data?.customerId?.name || 'NA'}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}>{data?.leadWonDate ? moment(data.leadWonDate).format('DD-MM-YYYY') : 'NA'}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}>{data?.salesWonUser?.name || 'NA'}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}>{data?.raisedQCDesigner?.name || 'NA'}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}>{data?.designAssistantManager?.name || 'NA'}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}>{data?.currentStage || 'NA'}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}>{data?.drawingQCStage || 'NA'}</StyledTableCell>
                  <StyledTableCell style={{ textAlign: 'center' }}><IoEye style={{ cursor: "pointer", fontSize: "25px" }} onClick={() => handleOpen(data)} /></StyledTableCell>
                  <>
                    <Modal
                      keepMounted
                      open={open}
                      onClose={handleClose}
                      aria-labelledby="keep-mounted-modal-title"
                      aria-describedby="keep-mounted-modal-description"
                    >
                      <Box
                        sx={{
                          ...styleForPopup,
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          backgroundColor: '#f9f9f9',
                          borderRadius: '10px',
                          padding: '20px',
                          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                          maxWidth: '600px',
                          width: '90%',
                        }}
                      >
                        {selectedRowData && (
                          <Table size="small" sx={{ minWidth: 500 }}>
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  align="center"
                                  style={{ fontWeight: 'bold', fontSize: '16px', background: '#F47E46', color: "white" }}
                                >
                                  Attachments
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{ fontWeight: 'bold', fontSize: '16px', background: '#F47E46', color: "white" }}
                                >
                                  Download
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {[
                                { label: 'Site Masking Documents', key: 'siteMaskingDocuments' },
                                { label: '2D Drawings', key: 'twoDDrawingsFile' },
                                { label: 'Site Photos/Videos', key: 'sitePhotosVideosFile' },
                                { label: 'Appliances Checklist', key: 'appliancesChecklistFile' },
                                { label: '3D PowerPoint (PPT)', key: 'powerPointFile' },
                              ].map((item, index) => (
                                <TableRow
                                  key={index}
                                  sx={{
                                    backgroundColor: index % 2 === 0 ? '#ffffff' : '#f1f1f1',
                                    '&:hover': { backgroundColor: '#e8f4ff' },
                                  }}
                                >
                                  <TableCell align="center">{item.label}</TableCell>
                                  <TableCell align="center">
                                    <FaDownload
                                      onClick={() => handleDownloadAll(selectedRowData.drawingQcAttachment?.[item.key] || [])}
                                      style={{
                                        cursor: 'pointer',
                                        fontSize: '25px',
                                        color: '#355025',
                                        transition: 'transform 0.2s, color 0.2s',
                                      }}
                                      onMouseOver={(e) => {
                                        e.currentTarget.style.color = '#1C375D';
                                        e.currentTarget.style.transform = 'scale(1.2)';
                                      }}
                                      onMouseOut={(e) => {
                                        e.currentTarget.style.color = '#355025';
                                        e.currentTarget.style.transform = 'scale(1)';
                                      }}
                                    />
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                            <TableBody>
                              <TableRow
                                sx={{
                                  backgroundColor: '#f1f1f1',
                                  '&:hover': { backgroundColor: '#e8f4ff' },
                                }}
                              >
                                <TableCell align="center">Quotation</TableCell>
                                <TableCell align="center">
                                  <FaExternalLinkAlt
                                    onClick={() => quoClick(selectedRowData.drawingQcAttachment?.quotationFile || [])}
                                    style={{
                                      cursor: 'pointer',
                                      fontSize: '25px',
                                      color: '#355025',
                                      transition: 'transform 0.2s, color 0.2s',
                                    }}
                                    onMouseOver={(e) => {
                                      e.currentTarget.style.color = '#1C375D';
                                      e.currentTarget.style.transform = 'scale(1.2)';
                                    }}
                                    onMouseOut={(e) => {
                                      e.currentTarget.style.color = '#355025';
                                      e.currentTarget.style.transform = 'scale(1)';
                                    }}
                                  />
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        )}
                      </Box>
                    </Modal>
                  </>
                  
                { 
                  !userDetails.roles.find(role=>role.name == ROLENAME.SalesManager || role.name == ROLENAME.SalesUser || role.name == ROLENAME.AssistantSalesManager   || role.name == ROLENAME.DesignUser || role.name == ROLENAME.Admin || role.name == ROLENAME.DGM_Sales || role.name == ROLENAME.AGMSales ) &&
                  <StyledTableCell style={{textAlign: 'center'}}>
                  <Button
                    className={classes.approveButton}
                    variant="contained"
                    onClick={(e) => handleApproveClick(e, data)}
                    >
                    Approve
                  </Button>
                  </StyledTableCell>
                }

                </StyledTableRow>
              </>
            ))}

            {emptyRows > 0 && (
              <StyledTableRow style={{ height: 53 * emptyRows }}>
                <StyledTableCell colSpan={9} />
              </StyledTableRow>
            )}
            
          </TableBody>

          {/* <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[10, 20, 50, { label: 'All', value: -1 }]}
                colSpan={6}
                count={designKickOffLeads.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { 'aria-label': 'rows per page' },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter> */}
          
        </Table>
      </TableContainer>        
      <Dialog
        open={showChecklist}
        onClose={() => setShowChecklist(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogContent style={{ padding: 0 }}>
          {selectedDataForChecklist && (
            <AdmCheckList  data={selectedDataForChecklist} setShowChecklist={setShowChecklist} setApprovalMsg={setApprovalMsg} />
          )}
        </DialogContent>
      </Dialog>

    </div>
  )
}

export default connect(null, { setLoading, setSnackInfo })(DrawingQcApproval)